export const validateTherapistInput = (value: any, values: any) => {
  return !values.isShared ||
    values.isShared === 'false' ||
    (values.isShared === 'true' && value)
    ? undefined
    : ['Required field'];
};
